/* ==========================================================================
   AURALENTI Member Dashboard

   Scoped to [data-aur-dash]. No network calls, no globals beyond a single
   IIFE, and no listeners bound outside the dashboard root. Safe to load on
   any page: it no-ops when the root is absent.

   No user-facing strings live here. The toast template comes from Liquid via
   data-aur-soon-template, already translated, with {label} substituted at
   click time. Adding copy to this file would bypass the dictionary.
   ========================================================================== */

(function () {
  'use strict';

  var TOAST_DURATION = 2600;
  var APPSTLE_SETTLE_MS = 15000;
  var toastTimer = null;

  /* Entry point ------------------------------------------------------------ */

  function init(root) {
    if (!root || root.dataset.aurDashReady === 'true') return;
    root.dataset.aurDashReady = 'true';

    setupNavToggle(root);
    setupPlaceholders(root);
    setupProtocolSelect(root);
    setupSubscriptionSlot(root);
  }

  /* Sidebar disclosure (mobile and tablet) --------------------------------- */

  function setupNavToggle(root) {
    var toggle = root.querySelector('[data-aur-nav-toggle]');
    var panel = root.querySelector('[data-aur-nav-panel]');
    if (!toggle || !panel) return;

    toggle.addEventListener('click', function () {
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!isOpen));
      panel.dataset.open = String(!isOpen);
    });
  }

  /* Placeholder destinations ----------------------------------------------- */

  function setupPlaceholders(root) {
    var targets = root.querySelectorAll('[data-aur-placeholder]');

    Array.prototype.forEach.call(targets, function (target) {
      target.addEventListener('click', function (event) {
        event.preventDefault();
        showToast(root, target.getAttribute('data-aur-placeholder') || '');
      });
    });
  }

  /* Protocol selector ------------------------------------------------------
     Each protocol is a [data-aur-protocol-set] block rendered server-side;
     the select toggles which one is visible. No toast, no navigation — the
     data is already on the page.
  -------------------------------------------------------------------------- */

  function setupProtocolSelect(root) {
    var select = root.querySelector('[data-aur-protocol-select]');
    if (!select) return;

    var sets = root.querySelectorAll('[data-aur-protocol-set]');
    if (!sets.length) return;

    var link = root.querySelector('[data-aur-protocol-link]');

    var show = function (handle) {
      Array.prototype.forEach.call(sets, function (set) {
        var match = set.getAttribute('data-aur-protocol-set') === handle;
        set.style.display = match ? '' : 'none';
      });
    };

    var syncLink = function () {
      if (!link) return;
      var opt = select.options[select.selectedIndex];
      var url = opt && opt.getAttribute('data-page-url');
      if (url) link.setAttribute('href', url);
    };

    show(select.value);
    syncLink();
    select.addEventListener('change', function () {
      show(select.value);
      syncLink();
    });
  }

  /* Appstle subscription slot ----------------------------------------------
     Appstle's Classic Customer Portal mounts its Manage Subscription control
     into a fixed placeholder id, only for customers with active
     subscriptions. We observe that slot and swap the card's copy
     accordingly, and hide our own fallback link so only one control shows.
     We never call Appstle's API or modify its markup.
  -------------------------------------------------------------------------- */

  function setupSubscriptionSlot(root) {
    var slot = root.querySelector('[data-aur-appstle-slot]');
    if (!slot) return;

    var empty = root.querySelector('[data-aur-sub-empty]');
    var active = root.querySelector('[data-aur-sub-active]');
    var fallback = root.querySelector('[data-aur-sub-fallback]');

    var sync = function () {
      var mounted = slot.children.length > 0 && slot.textContent.trim() !== '';

      if (empty) empty.hidden = mounted;
      if (active) active.hidden = !mounted;
      if (fallback) fallback.hidden = mounted;
      slot.dataset.mounted = String(mounted);
    };

    sync();

    if (!('MutationObserver' in window)) return;

    var observer = new MutationObserver(sync);
    observer.observe(slot, { childList: true, subtree: true });

    window.setTimeout(function () {
      observer.disconnect();
      sync();
    }, APPSTLE_SETTLE_MS);
  }

  /* Toast ------------------------------------------------------------------
     The template arrives translated from Liquid, e.g. '{label} arrive
     bientôt'. If it is missing we fall back to the label alone rather than
     inventing English copy.
  -------------------------------------------------------------------------- */

  function showToast(root, label) {
    var toast = root.querySelector('[data-aur-toast]');
    if (!toast) return;

    var template = root.getAttribute('data-aur-soon-template') || '';
    var message = template ? template.replace('{label}', label) : label;

    toast.textContent = message;
    toast.dataset.visible = 'true';

    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () {
      toast.dataset.visible = 'false';
    }, TOAST_DURATION);
  }

  /* Boot ------------------------------------------------------------------- */

  function boot(scope) {
    var container = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(container.querySelectorAll('[data-aur-dash]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  // Re-initialise after a theme-editor section reload.
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
